var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active-button-contain"},[_c('img',{ref:"couponImgRef",staticClass:"coupon-img",attrs:{"src":_vm.imgUrl,"alt":"优惠券"},on:{"click":_vm.getCoupon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }